import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';

import { toastError, toastSuccess } from "../../utils/react-toaster";
import { deleteAccountData, getAllAccountsData, saveAccountData, saveAllAccountsData } from "../slices";

export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string,
  success?: boolean
  code?: any;
  results?: any;
  productvo?: any;
}


function* fetchAllAccountsData(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.ACCOUNTS.getAllAccountsApi
    })
    if (response) {
      yield put(saveAllAccountsData(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteAccount(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.ACCOUNTS.deleteAccountApi(actions.payload.mid),
    })
    if (response.code) {
      toastError(response.code);
      actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(true);
    }
  } catch (error) {
    actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

function* saveAccount(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTS.saveAccountApi,
      data: actions.payload.dataToPost
    })
    if (!response?.code) {
      actions.payload.callback(response);
    }
  } catch (error) {
    // actions.payload.callback(false);
    console.log(error);
  }
}



export default function* root() {
  yield takeEvery(saveAccountData.type, saveAccount);
  yield takeEvery(getAllAccountsData.type, fetchAllAccountsData);
  yield takeEvery(deleteAccountData.type, deleteAccount);
}

